import { render, staticRenderFns } from "./CategoryAssign.vue?vue&type=template&id=9a0dfaa6"
import script from "./CategoryAssign.vue?vue&type=script&lang=js"
export * from "./CategoryAssign.vue?vue&type=script&lang=js"
import style0 from "./CategoryAssign.vue?vue&type=style&index=0&id=9a0dfaa6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports